import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../../api";
import { ICargo, IProfile } from "../../../../interfaces"
import { Utils } from "../../../../utils";

export const NftHomeCreators = () => {
  const projectCode = 'NFT';
  const api = useApi(projectCode);
  const navigate = useNavigate();
  const [mounted, setMounted] = useState<boolean>(false);
  const [creators, setCreators] = useState<IProfile []>([]);

  useEffect(() => {
    if (mounted) return
    setMounted(true);
    api.getSelectedCreators((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setCreators(cargo.info);
      }
    })
  }, [api, mounted])

  return (
    <>
      <div className="grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8 px-3 mx-auto" style={{ maxWidth: '1280px' }}>
        {
          creators.map((profile, index) => {
            if (!profile.avator || !profile.nickname) return null;
            return (
              <div key={index} className="d-flex align-items-center p-2 radius-12 creater cursor-pointer" onClick={() => {
                if (profile.simpleCode) {
                  navigate(`/web/creator/${profile.simpleCode}`)
                }
              }}>
                <img src={Utils().normalizeImagePath(profile.avator, projectCode)} className="me-3 radius-12" style={{ width: '64px' }} alt="" />
                <div className="d-flex flex-column justify-between" style={{ maxWidth: '75%' }}>
                  <div className="mb-2 txt-row-1">{profile.nickname}</div>
                  <div className="txt-12 text-gray-500 w-100 txt-row-1">{profile.simpleCode}</div>
                </div>
              </div>
            )
          })
        }
      </div>
    </>
  )

}